export const FA_ANGLE_LEFT = 'farAngleLeft'
export const FA_ARROW_ALT_BOTTOM = 'faArrowAltToBottom'
export const FA_ARROW_UP = 'fasArrowUp'
export const FA_CALENDAR_ALT = 'falCalendarAlt'
export const FA_CALENDAR_EXCLAMATION = 'falCalendarExclamation'
export const FA_CHECK = 'falCheck'
export const FA_CHECK_CIRCLE = 'falCheckCircle'
export const FA_CHEVRON_DOWN = 'farChevronDown'
export const FA_CHEVRON_UP = 'farChevronUp'
export const FA_CIRCLE = 'fasCircle'
export const FA_CLOCK = 'farClock'
export const FA_CREDIT_CARD = 'falCreditCard'
export const FA_EXCLAMATION_CIRCLE = 'farExclamationCircle'
export const FA_EXCLAMATION_TRIANGLE = 'fasExclamationTriangle'
export const FA_FAX = 'fasFax'
export const FA_LOCK_ALT = 'farLockAlt'
export const FA_MINUS = 'falMinus'
export const FA_PLUS_CIRCLE = 'fasPlusCircle'
export const FA_REPLY = 'fasReply'
export const FA_SEARCH = 'fasSearch'
export const FA_TIMES = 'falTimes'
export const FA_UNDO = 'farUndo'
export const FAL_USER_CHECK = 'falUserCheck'
export const FAR_QUESTION = 'farQuestionCircle'
export const FAS_CHECK = 'fasCheck'
export const FAS_EXCLAMATION_CIRCLE = 'fasExclamationCircle'
export const FAS_QUESTION_CIRCLE = 'fasQuestionCircle'
